import { Authentication } from '@leedpulse-monorepo/classes';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';

// ─── Cancel a single number from the company's Stripe subscription ───────────

interface CancelNumberPayload {
  /** Internal subscription document ID */
  subscription_id: string;
  /** Firestore company ID */
  company_id: string;
  /** Company API key for security validation */
  company_api_key: string;
}

interface CancelNumberResponse {
  /** Phone number(s) of the cancelled subscription */
  cancelled_subscription_number: string[];
  /** Timestamp (ms) when the cancellation takes effect (end of billing period) */
  effective_date: number;
}

/**
 * Schedule a number for cancellation at the end of the current billing period.
 * The number stays active until `effective_date`.
 */
export async function cancelNumber(
  payload: CancelNumberPayload,
  auth: Authentication,
): Promise<CancelNumberResponse> {
  try {
    const { company_api_key, ...body } = payload;
    const response = await HttpClient.post(
      '/leedflow/stripe/subscription/cancel-number',
      body,
      auth.token,
      false,
      {
        'x-api-key': company_api_key,
        'x-user-uid': auth.id,
      },
    );

    return response.data;
  } catch (e) {
    console.error('cancelNumber error:', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new CancelNumberFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new CancelNumberFailure(e.message);
    }
    return Promise.reject(e);
  }
}

// ─── Failure class ───────────────────────────────────────────────────────────

export class CancelNumberFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}
